import { SitesService } from './../services/sites.service';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { Site } from '@classes/site';


@Injectable()
export class SitesResolver  {
    constructor(
        private sitesSrv: SitesService,
        private uiSrv: UiService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Site[]> {
        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.sitesSrv.getList()
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            })
        );
    }
}
